var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',_vm._l((_vm.tabs),function(tab){return _c('li',{key:tab.name},[_c('router-link',{staticClass:"hover:font-bold hover:text-secondary text-xl font-family-inter",class:{
        'text-primary font-bold': _vm.pathAtual === tab.path,
      },attrs:{"to":tab.path}},[_vm._v(" "+_vm._s(tab.name)+" ")])],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }